import React, { useEffect, useState } from "react";
import logo from "../assets/logo1.png"

export default function Navbar() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onResize = () => window.innerWidth >= 768 && setOpen(false);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  const go = (id) => {
    setOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header className="sticky top-0 z-50 bg-white/90 backdrop-blur shadow-md border-b border-slate-200">
      <div className="max-w-6xl mx-auto px-4 md:px-8">
        <div className="h-16 flex items-center justify-between">
          {/* Logo */}
          <div className="flex items-center gap-3">
            {/* Optional image logo (public/images/imdady-logo.png) */}
            <img
              src={logo}
              alt="Imdady"
              className="h-10 w-auto"
              onError={(e) => (e.currentTarget.style.display = "none")}
            />
            {/* <span className="text-xl font-extrabold text-[#7533AF] tracking-tight">
              Imdady
            </span> */}
          </div>

          {/* Desktop */}
          <nav className="hidden md:flex items-center gap-8 text-sm font-medium text-slate-700">
            <button onClick={() => go("features")} className="hover:text-[#7533AF]">
              Features
            </button>
            <button onClick={() => go("pricing")} className="hover:text-[#7533AF]">
              Pricing
            </button>
            <button onClick={() => go("contact")} className="hover:text-[#7533AF]">
              Contact Us
            </button>

            <button
              onClick={() => go("pricing")}
              className="ml-2 rounded-lg bg-[#7533AF] px-5 py-2 text-sm font-semibold text-white hover:opacity-90 shadow-sm"
            >
              Get Started
            </button>
          </nav>

          {/* Mobile */}
          <button
            className="md:hidden inline-flex items-center justify-center rounded-lg border border-slate-200 px-3 py-2 text-slate-700"
            onClick={() => setOpen((v) => !v)}
            aria-label="Toggle menu"
          >
            ☰
          </button>
        </div>

        {/* Mobile dropdown */}
        {open && (
          <div className="md:hidden pb-4">
            <div className="flex flex-col gap-2 text-sm font-medium text-slate-700">
              <button
                onClick={() => go("features")}
                className="text-left px-3 py-2 rounded-lg hover:bg-slate-50"
              >
                Features
              </button>
              <button
                onClick={() => go("pricing")}
                className="text-left px-3 py-2 rounded-lg hover:bg-slate-50"
              >
                Pricing
              </button>
              <button
                onClick={() => go("contact")}
                className="text-left px-3 py-2 rounded-lg hover:bg-slate-50"
              >
                Contact Us
              </button>

              <button
                onClick={() => go("pricing")}
                className="mt-2 rounded-lg bg-[#7533AF] px-5 py-2 text-sm font-semibold text-white hover:opacity-90 shadow-sm"
              >
                Get Started
              </button>
            </div>
          </div>
        )}
      </div>
    </header>
  );
}
